import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ScrollReveal from "./scroll-reveal";

const stats = [
  {
    id: 1,
    number: 500,
    suffix: "+",
    label: "Happy Clients",
    icon: "fas fa-users",
  },
  {
    id: 2,
    number: 15,
    suffix: "+",
    label: "Years Experience",
    icon: "fas fa-calendar-alt",
  },
  {
    id: 3,
    number: 1000,
    suffix: "+",
    label: "Projects Completed",
    icon: "fas fa-project-diagram",
  },
  {
    id: 4,
    number: 50,
    suffix: "+",
    label: "Cities Served",
    icon: "fas fa-map-marker-alt",
  },
];

function CountUp({ end, duration = 2000, suffix = "" }: { end: number; duration?: number; suffix?: string }) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isVisible) return;

    const startTime = Date.now();
    const endTime = startTime + duration;

    const timer = setInterval(() => {
      const now = Date.now();
      const remaining = Math.max((endTime - now) / duration, 0);
      const value = Math.round(end - remaining * end);

      if (remaining === 0) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(value);
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end, duration, isVisible]);

  return (
    <ScrollReveal>
      <div ref={() => setIsVisible(true)}>
        <span>{count.toLocaleString()}{suffix}</span>
      </div>
    </ScrollReveal>
  );
}

export default function StatsSection() {
  return (
    <section className="py-20 bg-accent/10 dark:bg-accent/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <ScrollReveal key={stat.id} delay={index * 0.1}>
              <motion.div
                className="text-center p-6 rounded-2xl glass-effect backdrop-blur-sm hover-lift hover-cursor"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <motion.div
                  className="w-12 h-12 bg-accent rounded-full flex items-center justify-center mx-auto mb-4"
                  whileHover={{ rotate: 360 }}
                  transition={{ duration: 0.6 }}
                >
                  <i className={`${stat.icon} text-white text-lg`}></i>
                </motion.div>
                <div className="text-3xl md:text-4xl font-bold text-primary dark:text-white mb-2">
                  <CountUp end={stat.number} suffix={stat.suffix} />
                </div>
                <p className="text-neutral dark:text-gray-300 font-medium">
                  {stat.label}
                </p>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}